import {
  EditOutlinedIcon,
  ForwardToInboxOutlinedIcon,
  MoreMenuIconButton,
} from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { SearchUsersByAppRoleFiltersDocument } from '@user-management/graphql';
import { UserStatus } from '@user-management/user-details';
import { useResendUserInvitationEmail } from '@user-management/user-invitation';
import { useMemo } from 'react';

import { useUserManagementListModal } from '../../providers';

interface MoreActionButtonProps {
  userId: string;
  userStatus: UserStatus;
}

export default function MoreActionButton(props: Readonly<MoreActionButtonProps>) {
  const { userId, userStatus } = props;
  const { showPromiseSnackbar } = useSnackbar();
  const { setAction } = useUserManagementListModal();

  const { resendUserInvitationEmail } = useResendUserInvitationEmail({
    userId: userId,
    refetchQueries: [SearchUsersByAppRoleFiltersDocument],
    awaitRefetchQueries: true,
  });

  const handleResendEmailInvitation = () => {
    showPromiseSnackbar({
      promise: resendUserInvitationEmail,
      message: {
        pending: 'Sending invitation',
        success: 'User invited successfully',
        error: 'Cannot send invitation',
      },
    });
  };

  const options = useMemo(
    () => [
      {
        label: 'Resend Invitation',
        icon: <ForwardToInboxOutlinedIcon />,
        enabled:
          userStatus === UserStatus.INVITATION_PENDING ||
          userStatus === UserStatus.INVITATION_EXPIRED,
        onClick: handleResendEmailInvitation,
      },
      {
        label: 'Edit',
        icon: <EditOutlinedIcon />,
        enabled: true,
        onClick: () => {
          setAction('edit', userId);
        },
      },
    ],
    [userStatus],
  );

  const filteredOptions = useMemo(() => {
    return options.filter((option) => option.enabled);
  }, [options]);

  return <MoreMenuIconButton options={filteredOptions} />;
}
